<div class="container mx-auto ">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
    <!-- w-full -->

    <div *ngFor="let ticket of tickets; trackBy: trackById">
      <a [routerLink]="isHomePage ? ['/ticket-event', auctionId()] : null"
        class="bg-white shadow-md rounded-lg p-3 flex flex-col h-full">

        <div class="flex">
          <img *ngIf="!ticket.imageUrl.includes('ticket-default.jpg')" [src]="ticket.imageUrl" [alt]="ticket.name"
            class="w-[150px] h-[90px] lg:w-[250px] lg:h-[110px] object-cover rounded-lg ">
          <div *ngIf="ticket.imageUrl.includes('ticket-default.jpg')" 
          class="flex flex-col">
            <app-default-image [element]="'ticket'"></app-default-image>
          </div>

          <div class="ml-7 flex flex-col justify-between w-full  overflow-hidden">
            <div class="break-words">
              <h3 class="text-[20px] font-semibold text-[var(--p-info-500)] font-mulish "
                [innerHTML]="ticket.name | sanitizeHtmlText">
              </h3>
              <p class="text-base font-bold font-mulish text-custom-black">{{ ticket.price }}</p>
              <p class="text-sm text-[var(--p-primary-500)] font-medium font-mulish"><span>Guest Included:</span> {{
                ticket.guestsIncluded }}</p>
              @if(ticketEventSignal()?.showQuantityRemaining){
              <p class="text-[14px] text-gray-500 font-mulish">Only {{ ticket.quantityAvailable }} available</p>
              }
            </div>
            <div *ngIf="!isHomePage" class="flex items-center gap-2 mt-3">
              <button pButton type="button" class="p-button-sm p-button-text" (click)="decrease(ticket)"
                [disabled]="ticket.quantitySelected! === 0">

                <i class="pi pi-minus"></i>

              </button>

              <input type="text " [(ngModel)]="ticket.quantitySelected" (input)="enforceMax($event, ticket)"
                (blur)="enforceMin(ticket)"
                class="px-3 py-1 text-[var(--p-primary-500)] border rounded text-center  text-[12px] w-[50px]"
                min="0" />
              <button pButton type="button" class="p-button-sm p-button-text" (click)="increase(ticket)"
                [disabled]="ticket.quantitySelected! >= ticket.maxPerOrder || ticket.quantitySelected! >= ticket.quantityAvailable">

                <i class="pi pi-plus" [ngClass]=" {
                'text-gray-700': ticket.quantitySelected! >= ticket.maxPerOrder,
                'text-[var(--p-primary-500)]': ticket.quantitySelected! <= ticket.maxPerOrder
              }"></i>

              </button>
              <button pButton type="button" icon="pi pi-trash" class="p-button-sm p-button-text text-red-600"
                (click)="onRemove(ticket)">
              </button>
            </div>
          </div>
        </div>

        @if(!isHomePage)
        {
        <p *ngIf="ticket.description" class="text-[14px] text-gray-500 font-mulish">
          <span [innerHTML]=" descriptionExpanded ? (ticket.description | sanitizeHtmlText) : (ticket.description |
            slice:0:120 | sanitizeHtmlText) "></span>


          <a *ngIf=" ticket.description && ticket.description.length > 120"
            class="text-custom-blue-head  text-xs cursor-pointer ml-1" (click)="toggleExpand()">
            {{descriptionExpanded ? 'See less' : 'See more'}}
          </a>

        </p>

        }


        <!-- <p class="text-[14px] text-gray-500 font-mulish" [innerHTML]="ticket.description | sanitizeHtmlText">
        </p> -->
      </a>


    </div>
  </div>
</div>